import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { BsCalendar2CheckFill, BsFillPeopleFill } from 'react-icons/bs';
import { GoClockFill } from 'react-icons/go';
import { IoArrowBackCircleOutline } from 'react-icons/io5';
import { formatDate } from '../WidgetConfig';

const ReservationSummary = ({
  restaurant,
  date,
  guest,
  selectedTime,
  onBack,
  userUrl,
  guestUrl,
  fullyBooked,
}) => {
  return (
    <>
      <Box>
        <Button onClick={onBack} startIcon={<IoArrowBackCircleOutline />}>
          Back
        </Button>
      </Box>
      <Box
        sx={{
          mt: 2,
          border: '1px solid #d7d7d7',
          borderRadius: '8px',
        }}
      >
        <Box sx={{ p: 2, borderBottom: '1px solid #d7d7d7' }}>
          <Typography color="primary" sx={{ fontWeight: 700 }}>
            Reservation Details
          </Typography>
        </Box>
        <Box
          sx={{
            p: 2,
            display: 'flex',
            columnGap: 2,
            borderBottom: '1px solid #d7d7d7',
          }}
        >
          <Box
            sx={{
              background: `url('${restaurant?.Photos[0]?.Link}')`,
              height: '100px',
              width: '100px',
              borderRadius: '8px',
              backgroundSize: 'cover',
            }}
          />
          <Box>
            <Typography sx={{ fontWeight: 600 }}>
              {restaurant?.RestaurantName}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                columnGap: 1,
                mt: 1,
              }}
            >
              <BsCalendar2CheckFill style={{ fontSize: '14px' }} />
              <Typography sx={{ fontSize: '12px' }}>
                {formatDate(date)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                columnGap: 1,
                mt: 0.4,
              }}
            >
              <BsFillPeopleFill style={{ fontSize: '14px' }} />
              <Typography sx={{ fontSize: '12px' }}>{`${guest} Guest`}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                columnGap: 1,
                mt: 0.4,
              }}
            >
              <GoClockFill style={{ fontSize: '14px' }} />
              <Typography sx={{ fontSize: '12px' }}>{selectedTime}</Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ p: 2 }}>
          <Link
            to={'/login'}
            state={{
              redirectTo: fullyBooked
                ? `${userUrl}waitlist=true`
                : `${userUrl}waitlist=false`,
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{ borderRadius: '12px', py: 2 }}
            >
              Login with Reisty
            </Button>
          </Link>
          <Typography sx={{ textAlign: 'center', my: 2 }}>or</Typography>
          <Link
            to={
              fullyBooked
                ? `${guestUrl}waitlist=true`
                : `${guestUrl}waitlist=false`
            }
          >
            <Button
              variant="outlined"
              fullWidth
              sx={{ borderRadius: '12px', py: 2 }}
            >
              Continue as Guest
            </Button>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default ReservationSummary;
